import { Observable } from 'rxjs';

import { SnLonLatLike } from '@lib/geo/helpers';

export abstract class BaseZoomManagementService {
  abstract setZoom(zoom: number): void;
  abstract getZoom(): number;
  abstract zoomIn(): void;
  abstract zoomOut(): void;
  abstract getMaxZoomAtLatLng?(location: SnLonLatLike): Observable<number>;
}
